import { Alert, Descriptions } from 'antd'
import { ZoneParams } from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'

import { getPlanningStrategy } from './planningStrategy'
import { InspectionArea, PlanningAreasConfig } from './planningTypes'
import { TechniqueCatalogue } from './techniqueTypes'
import { ZoneQuantitySummary } from './ZoneQuantitySummary'

export const InspectionZoneSummary = ({
  zone,
  strategyConfig,
  requiredArea,
  recommendation,
  areas,
  config,
  catalogue,
}: {
  zone: ZoneParams
  strategyConfig: ReturnType<typeof getPlanningStrategy>
  requiredArea: number | undefined
  recommendation: string | null | undefined
  areas: readonly InspectionArea[]
  config: PlanningAreasConfig
  catalogue: TechniqueCatalogue
}) => (
  <>
    <Descriptions
      column={1}
      bordered
      items={[
        {
          key: 'strategy',
          label: 'NII strategy',
          children:
            strategyConfig.strategyType ?? 'Not specified in source assessment',
        },
        {
          key: 'coverage',
          label: 'Required coverage',
          children:
            strategyConfig.plannedCoveragePercent === undefined
              ? 'Not specified in source assessment'
              : `${strategyConfig.plannedCoveragePercent}%`,
        },
        {
          key: 'damage',
          label: 'Damage mechanisms',
          children:
            zone.damage_mechanisms?.map((item) => item.name).join(', ') ||
            'Not specified',
        },
        {
          key: 'recommendation',
          label: 'NII recommendations',
          children:
            recommendation ||
            zone.zone_recommendations?.join('\n') ||
            'Not specified',
        },
      ]}
    />
    {strategyConfig.guidance && (
      <Alert type='info' title={strategyConfig.guidance} />
    )}
    <ZoneQuantitySummary
      areas={areas}
      requiredArea={requiredArea}
      config={config}
      catalogue={catalogue}
    />
  </>
)
